import { useEffect, useState } from "react";
import "./CourseAds.scss";
import _ from "lodash";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import CONFIG from "../../../../utils/config";
const CourseAds = (props) => {
  const {type} = props;
  const navigate = useNavigate();
  const [url,setUrl] = useState("")
  const [start,setStart] = useState(false);
  const [end,setEnd] = useState(false);
  useEffect(()=>{
    if(!_.isEmpty(type)){
      if(type==="video"){
        setUrl("/images/video_banner.png")
      }else if(type==="course"){
        setUrl("/images/course_banner.png")
      }else if(type==="partner"){
        setUrl("/images/partner_banner.png")
      }
    }
  },type)

  useEffect(()=>{
    const specificStartDate = moment.tz(CONFIG.OFFER_START_TIME, "America/New_York");
    const specificEndDate = moment.tz(CONFIG.OFFER_END_TIME, "America/New_York");
    const currentDate = moment.tz(new Date(), "America/New_York");
    setStart(currentDate.isAfter(specificStartDate));
    setEnd(currentDate.isBefore(specificEndDate))

  },[])

  
  return (

    <>
      {(start && end)?<div className="ads-wrapper d-flex gap-4 flex-column mt-4 mb-4 align-items-center">
        <div className="ads cursor-pointer" onClick={()=>{
          if(type==="video"){
            navigate("/learn/courses?tab=1&utm_source=Platform&utm_medium=Videos&utm_campaign=FlashSale2024")
          }else if(type==="course"){
            navigate("/learn/courses?tab=1&utm_source=Platform&utm_medium=Courses&utm_campaign=FlashSale2024")
          }else if(type==="partner"){
            navigate("/learn/courses?tab=1&utm_source=Platform&utm_medium=SideBannerPartners&utm_campaign=FlashSale2024")
          }
        }} >
          <img src={url} className="img-fluid" alt="ads" />
          {/* <div className="clickhere"></div> */}
        </div>
        {false && <div className="ads">
          <img src="/images/righ_pannel_banner2.png" className="img-fluid" alt="ads" />
          {/* <div className="clickhere"></div> */}
        </div>}
      </div>:""}
    </>
  );
};

export default CourseAds;
